import React from 'react';
import {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining
} from './final.js';

class MorningOpenPrePlayers extends React.Component {
  label = () => {
    return "Участники";
  }

  message = () => {
    return "На турнир пока никто не записан";
  }

  players = () => {
    return (
      <PlayersInner
        label={this.label()}
        message={this.message()}
        players={this.props.game.playersWithoutPayment}
        totalPlayersNum={this.props.game.totalPlayersWithoutPaymentNum}
        playersCount={false}
        flag={""}
      />
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.players()}
      </React.Fragment>
    )
  }
}

export default MorningOpenPrePlayers;
